import { deriveClientAddress, deriveClientDescription, deriveClientPackageName } from '~appointments/lib/derive';
import { onChangeClient } from '~appointments/lib/onchange';
import { showClientDescription } from '~appointments/lib/show';

import { FieldProps } from '~components/form-fields';

import { commonFields } from '~appointments/forms/appointment/common';

import { getAll as getClients } from '~main/actions/clients';

import { selectLookupClients } from '~main/selectors/clients/clients';

const commonNewFields: FieldProps = {
  ...commonFields,
  client_name: {
    type: 'select-lazy',
    field: 'client_id',
    caption: 'Client / Facility',
    deriveDescription: deriveClientAddress,
    onChange: onChangeClient,
    className: 'text-left',
    required: true,
    colSize: 4,
    order: 200,
    selectorOptions: selectLookupClients,
    selectorActions: getClients,
    manualReload: true,
  },
  client_description: {
    type: 'alert-info',
    className: 'form-notes',
    field: 'client.description',
    colSize: 4,
    show: showClientDescription,
    deriveValue: deriveClientDescription,
    order: 400,
  },
  client_package_name: {
    type: 'readonly',
    caption: 'Default Package',
    deriveValue: deriveClientPackageName,
    className: 'text-left',
    order: 220,
  },
};

export default commonNewFields;
